import {
  ArrayParam,
  JsonParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { KPI } from '../TopPerformingAds/__generated__/TopPerformingAdsQuery.graphql'
import { LabelType } from '../InsightsTable/__generated__/InsightsTableQuery.graphql'


const INSIGHTS_FILTER_PARAMS = {
  labelType: withDefault(ArrayParam, ['VIDEO', 'IMAGE', 'PHRASE', 'TAG'] as unknown as LabelType[]),
  insightKpi: withDefault(StringParam, 'PURCHASES_TO_LPV') as unknown as KPI,
  performanceDateGte: StringParam,
  performanceDateLte: StringParam,
  insightMetricsFilters: JsonParam,
  aiDateRange: StringParam,
} as const

const ADS_FILTER_PARAMS = {
  contentType: withDefault(ArrayParam, ['VIDEO', 'IMAGE', 'TEXT']),
  adKpi: withDefault(StringParam, 'PURCHASES_TO_LPV') as unknown as KPI,
  performanceDateGte: StringParam,
  performanceDateLte: StringParam,
  deduplicateAdNames: StringParam,
  previewFormat: StringParam,
  topAdMetricsFilters: JsonParam,
  bottomAdMetricsFilters: JsonParam,
} as const

export const useAdsFilterMenuParams = () => {
  return useQueryParams(ADS_FILTER_PARAMS)
}

export const useInsightsFilterMenuParams = () => {
  return useQueryParams(INSIGHTS_FILTER_PARAMS)
}
